import { render, staticRenderFns } from "./AtendimentoLeilao.vue?vue&type=template&id=11bcb0a5&"
import script from "./AtendimentoLeilao.vue?vue&type=script&lang=js&"
export * from "./AtendimentoLeilao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports